import React from 'react';
import {Link} from "react-router-dom";
import {useSelector} from "react-redux";

import Switcher from '../../../components/Switcher';
import panel from '../../../components/Panel.module.scss';
import Routes from "../../../components/Routes";
import {ReactComponent as ArrowRight} from "../../../styles/icon/arrowRight.svg";

const WebhookBreadcrumbs = () => {
    const data = useSelector((state) => state.apps.appDetails.data);
    if (!data) return null;
    return (
        <div className={panel.panel}>
            <div className={panel.panel__container}>
                <div className={panel.panel__disc_wrap}>
                    <div className={panel.panel__disc_webhook}>
                        <Link to={Routes.routes.ROOT.path}>
                            <strong>Home</strong>
                        </Link>
                        <ArrowRight/>
                    </div>

                    <div className={panel.panel__disc_webhook}>
                        <Link to={Routes.routes.APPLIST.path}>
                            <strong>Apps</strong>
                        </Link>
                        <ArrowRight/>
                    </div>

                    <div className={panel.panel__disc_webhook}>
                        <Link to={Routes.routes.APPS.routes.WEBHOOKS.path.replace(':id', data['id'])}>
                            <strong>Webhooks</strong>
                        </Link>
                        <ArrowRight/>
                    </div>

                    <div className={panel.panel__disc_webhook}>
                        <span id={'webhook-breadcrumb-id'}/>
                    </div>
                </div>
                <div className={panel.panel__right}>
                    <Switcher handleDiameter={24} height={16} width={38}/>
                </div>
            </div>
        </div>
    );
};

export default WebhookBreadcrumbs;
